/** Safe presentation and recovery details. Never show raw HTTP or record data in the dialog. */
export class PdfExportError extends Error {
  constructor(
    public readonly messageKey: string,
    public readonly retryable = false,
    public readonly recoveryMessageKey?: string,
    options?: ErrorOptions
  ) {
    super(messageKey, options);
    this.name = 'PdfExportError';
  }
}
